import { render, staticRenderFns } from "./SingleSlider.vue?vue&type=template&id=7866b1be&lang=pug&"
import script from "./SingleSlider.vue?vue&type=script&lang=js&"
export * from "./SingleSlider.vue?vue&type=script&lang=js&"
import style0 from "./SingleSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports